import ToolTipRight from './ToolTipRight';

export default ToolTipRight;
